import { render } from "./EnMenuItem.vue?vue&type=template&id=5228bc01&ts=true"
import script from "./EnMenuItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnMenuItem.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/base/EnMenu/EnMenuItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5228bc01"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5228bc01', __exports__)) {
    api.reload('5228bc01', __exports__)
  }
  
  module.hot.accept("./EnMenuItem.vue?vue&type=template&id=5228bc01&ts=true", () => {
    api.rerender('5228bc01', render)
  })

}


export default __exports__